module.exports = __webpack_public_path__ + "static/media/gif-3.83d85dd4.gif";